import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import TEXT from '../../../assets/constants';

export const generatePdf = async (element, footnotes) => {
  try {
    const canvas = await html2canvas(element, {
      backgroundColor: null,
      scale: 2,
      logging: false,
      useCORS: true,
      allowTaint: true,
    });

    const imgData = canvas.toDataURL('image/png');

    const { width, height } = canvas;
    const orientation = width > height ? 'landscape' : 'portrait';
    const doc = new jsPDF({ orientation, unit: 'pt', format: 'a4' });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const scale = Math.min(pageWidth / width, pageHeight / height) * 0.9;
    const imgWidth = width * scale * 0.75;
    const imgHeight = height * scale * 0.75;
    const marginX = (pageWidth - imgWidth) / 2;
    const marginY = (pageHeight - imgHeight) / 5;

    doc.addImage(imgData, 'PNG', marginX, marginY, imgWidth, imgHeight);

    if (footnotes && footnotes.length > 0) {
      const footnoteStartY = marginY + imgHeight + 30;
      let currentY = footnoteStartY;

      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(marginX, currentY - 10, pageWidth - marginX, currentY - 10);

      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 40, 91);
      doc.text('Calculation Details:', marginX, currentY);
      currentY += 20;

      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(60, 60, 60);
      footnotes.forEach((footnote) => {
        if (currentY > pageHeight - 40) {
          doc.addPage();
          currentY = 40;
        }

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(6);
        doc.text(footnote.label, marginX, currentY - 4);

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);

        const maxWidth = pageWidth - marginX * 2 - 20;
        const lines = doc.splitTextToSize(footnote.text, maxWidth);

        lines.forEach((line, lineIndex) => {
          if (lineIndex === 0) {
            doc.text(line, marginX + 8, currentY);
          } else {
            currentY += 12;
            doc.text(line, marginX + 8, currentY);
          }
        });

        currentY += 18;
      });

      doc.setTextColor(0, 0, 0);
    }

    doc.save(TEXT.PDF_FILE_NAME);
  } catch (error) {
    console.error('Failed to generate PDF:', error);
  }
};
